<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Demand {{ demand?.Id }} ({{ demand?.Type }})
        <span class="badge" [ngClass]="statusBadgeClass">{{ getDemandStatus }}</span>
      </h4>
      <p>View demand information.</p>
    </div>
    <div class="action-container" *ngIf="isAdmin && !isArchived">
      <button type="button"
              *ngIf="canSignoffOrReject"
              class="btn btn-success"
              (click)="signOffAll()"
              data-test="SignOffAll">
        Sign Off
      </button>
      <button type="button"
              class="btn btn-primary"
              style="margin-left: 8px;"
              [disabled]="isRefreshing"
              (click)="refreshDemandItems()"
              data-test="RefreshDemandItems">
        Refresh
      </button>
      <button type="button"
              *ngIf="canSignoffOrReject"
              class="btn btn-danger"
              style="margin-left: 8px;"
              (click)="rejectAll()"
              data-test="RejectAll">
        Reject
      </button>
    </div>
  </div>
</div>

<div class="container container-content container-max-width" (window:resize)="onResize()">
  <form novalidate class="form-horizontal mb-5">
    <div class="landing-main" *ngIf="demand">
      <fieldset class="fieldsetstyle">
        <div class="top-panel" style="height: fit-content">
          <ul class="list-container col-md-10">
            <li class="flex-box mb-3" *ngIf="demand.CreatedTime">
              <div class="col-md-2 label">Created Time (UTC)</div>
              <div class="col-md-10 value">{{ processedCreatedTime }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="demand.CustomerType">
              <div class="col-md-2 label">Customer</div>
              <div class="col-md-10 value">{{ demand.CustomerType }} - {{ demand.OwningTeam }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="isFirstPartyCustomer">
              <div class="col-md-2 label">Service</div>
              <div class="col-md-10 value">{{ demand.ServiceTeam }}({{ demand.ServiceTreeId }})</div>
            </li>
            <li class="flex-box mb-3" *ngIf="demand.DemandOrigin">
              <div class="col-md-2 label">Origin</div>
              <div class="col-md-10 value">{{ demand.DemandOrigin }} - {{ demand.DemandSource }} - {{ demand.SourceSystem }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="demand.BusinessPriority">
              <div class="col-md-2 label">Business Priority</div>
              <div class="col-md-10 value">{{ demand.BusinessPriority }}</div>
            </li>
            <li class="flex-box mb-3" *ngIf="demand.PlatformScenario">
              <div class="col-md-2 label">Platform Scenario</div>
              <div class="col-md-10 value">{{ demand.PlatformScenario }}</div>
            </li>
          </ul>
        </div>
      </fieldset>

      <fieldset>
        <h5>Tables</h5>
        <hr />

        <div class="card mb-4">
          <div class="card-header">
            <span class="bold-font">Demand Items</span>
          </div>
          <div class="card-block p-3">
            <ag-grid-angular
              id="DemandItemGrid"
              style="width: 100%"
              class="ag-theme-balham"
              [gridOptions]="demandItemGridOptions"
              [rowData]="demandItemRowData"
              [pagination]="true"
              [domLayout]="'autoHeight'"
              (gridReady)="onDemandItemGridReady($event)">
            </ag-grid-angular>
          </div>
        </div>
        <div class="card mb-4">
          <div class="card-header">
            <span class="bold-font">Demand Item Expanded (aggregated by zone)</span>
          </div>
          <div class="card-block p-3">
            <ag-grid-angular
              id="DemandItemExpandedGrid"
              style="width: 100%"
              class="ag-theme-balham"
              [gridOptions]="demandItemExpandedGridOptions"
              [rowData]="demandItemExpandedRowData"
              [pagination]="true"
              [domLayout]="'autoHeight'"
              (gridReady)="onDemandItemExpandedGridReady($event)">
            </ag-grid-angular>
          </div>
        </div>
        <div class="card mb-4">
          <div class="card-header">
            <span class="bold-font">History</span>
          </div>
          <div class="card-block p-3">
            <ag-grid-angular
              id="DemandHistoryGrid"
              style="width: 100%"
              class="ag-theme-balham"
              [gridOptions]="demandHistoryGridOptions"
              [rowData]="demandHistoryRowData"
              [pagination]="true"
              [domLayout]="'autoHeight'"
              (gridReady)="onDemandHistoryGridReady($event)">
            </ag-grid-angular>
          </div>
        </div>
      </fieldset>
    </div>
  </form>
</div>
